import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { environment } from '../../../environment';

export const ContactSupportButton = () => {
  const { t } = useTranslation();
  const helpUrlDomain = environment.VITE_IS_GOV ? 'teamworkstactical' : 'teamworks';

  return (
    <Button
      component="a"
      href={`https://help.${helpUrlDomain}.com/support/s/new`}
      target="_blank"
      rel="noopener noreferrer"
      variant="outlined"
    >
      {t('contactSupport')}
    </Button>
  );
};
